import Model from './Model'

export default class ExchangeRate extends Model {
  resource () { return 'exchangerates' }
}
